module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed w-full inset-0 flex items-end justify-center bg-gray-500 bg-opacity-50 z-50",
    attrs: {
      "role": "dialog",
      "aria-modal": "true"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-up",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "bg-white rounded-lg shadow-lg w-full relative",
    staticStyle: {
      "height": "96vh"
    }
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-31dffdb9!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Dialogs/Dialog.vue
// module id = 940
// module chunks = 61